<template>
    <div>
    </div>
</template>

<script>
    export default {
		mounted() {
			window.opener.postMessage(window.location.search, window.opener.location.origin);
			window.close();
		}
	}
</script>
